import { ensureHttpProtocol } from "./ensureHttpProtocol";

const DEFAULT_BUTTON_COLORS = {
    color: "#000000",
    background: "#ffffff",
};

const ICON_CHOICES = {
    continue: [
        "fa-solid fa-caret-right",
        "fa-regular fa-caret-right",
        "fa-solid fa-circle-caret-right",
        "fa-regular fa-circle-caret-right",
        "fa-solid fa-square-caret-right",
        "fa-regular fa-square-caret-right",
        "fa-solid fa-arrow-right",
        "fa-sharp fa-solid fa-arrow-right",
        "fa-solid fa-chevron-right",
        "fa-sharp fa-solid fa-chevron-right",
        "fa-solid fa-chevrons-right",
        "fa-sharp fa-solid fa-chevrons-right",
        "fa-solid fa-circle-chevron-right",
        "fa-regular fa-circle-chevron-right",
        "fa-solid fa-square-chevron-right",
        "fa-regular fa-square-chevron-right",
    ],
    share: [
        "fa-solid fa-share-nodes",
        "fa-regular fa-share-nodes",
        "fa-solid fa-share",
        "fa-regular fa-share",
        "fa-sharp fa-solid fa-share",
        "fa-sharp fa-regular fa-share",
        "fa-solid fa-share-all",
        "fa-regular fa-share-all",
        "fa-solid fa-share-from-square",
        "fa-regular fa-share-from-square",
        "fa-solid fa-circle-share-nodes",
        "fa-regular fa-circle-share-nodes",
        "fa-solid fa-square-share-nodes",
        "fa-regular fa-square-share-nodes",
    ],
    redirect: [
        "fa-solid fa-link",
        "fa-sharp fa-solid fa-link",
        "fa-solid fa-browser",
        "fa-regular fa-browser",
        "fa-solid fa-globe",
        "fa-regular fa-globe",
        "fa-solid fa-globe-pointer",
        "fa-regular fa-globe-pointer",
    ],
    phone: [
        "fa-solid fa-phone",
        "fa-regular fa-phone",
        "fa-solid fa-mobile",
        "fa-regular fa-mobile",
        "fa-solid fa-phone-arrow-right",
        "fa-regular fa-phone-arrow-right",
        "fa-solid fa-phone-arrow-up-right",
        "fa-regular fa-phone-arrow-up-right",
        "fa-solid fa-phone-flip",
        "fa-regular fa-phone-flip",
        "fa-solid fa-circle-phone",
        "fa-regular fa-circle-phone",
        "fa-solid fa-square-phone",
        "fa-regular fa-square-phone",
    ],
    email: [
        "fa-solid fa-envelope",
        "fa-regular fa-envelope",
        "fa-solid fa-at",
        "fa-solid fa-circle-envelope",
        "fa-regular fa-circle-envelope",
        "fa-solid fa-envelopes",
        "fa-regular fa-envelopes",
    ],
    sms: [
        "fa-solid fa-commenting",
        "fa-regular fa-commenting",
        "fa-solid fa-comment-captions",
        "fa-regular fa-comment-captions",
        "fa-solid fa-comment-heart",
        "fa-regular fa-comment-heart",
        "fa-solid fa-comment-image",
        "fa-regular fa-comment-image",
        "fa-solid fa-comment-lines",
        "fa-regular fa-comment-lines",
    ],
};

export const CONNECT_BUTTON_PRESETS = {
    continue: {
        value: "continue",
        label: "Continue Browsing",
        type: "continue",
        defaultText: "Continue Browsing",
        icon: "fa-solid fa-caret-right",
        placeholder: "",
        colors: DEFAULT_BUTTON_COLORS,
        iconChoices: ICON_CHOICES.continue,
        usesOriginUrl: true,
        utmSource: "continue",
    },
    redirect: {
        value: "redirect",
        label: "URL",
        type: "redirect",
        defaultText: "Visit Website",
        icon: "fa-solid fa-link",
        placeholder: "URL",
        colors: DEFAULT_BUTTON_COLORS,
        iconChoices: ICON_CHOICES.redirect,
        usesOriginUrl: false,
        utmSource: "url",
    },
    facebook: {
        value: "facebook",
        label: "Facebook",
        type: "redirect",
        platform: "facebook",
        defaultText: "Facebook",
        icon: "fa-brands fa-facebook",
        placeholder: "Username or Facebook URL",
        colors: { color: "#ffffff", background: "#1877F2" },
        iconChoices: ["fa-brands fa-facebook"],
        usesOriginUrl: false,
        utmSource: "facebook",
    },
    instagram: {
        value: "instagram",
        label: "Instagram",
        type: "redirect",
        platform: "instagram",
        defaultText: "Instagram",
        icon: "fa-brands fa-instagram",
        placeholder: "Username or Instagram URL",
        colors: { color: "#ffffff", background: "#E4405F" },
        iconChoices: ["fa-brands fa-instagram"],
        usesOriginUrl: false,
        utmSource: "instagram",
    },
    linkedin: {
        value: "linkedin",
        label: "LinkedIn",
        type: "redirect",
        platform: "linkedin",
        defaultText: "LinkedIn",
        icon: "fa-brands fa-linkedin",
        placeholder: "Profile slug or LinkedIn URL",
        colors: { color: "#ffffff", background: "#0A66C2" },
        iconChoices: ["fa-brands fa-linkedin"],
        usesOriginUrl: false,
        utmSource: "linkedin",
    },
    x: {
        value: "x",
        label: "X",
        type: "redirect",
        platform: "x",
        defaultText: "X",
        icon: "fa-brands fa-x-twitter",
        placeholder: "Handle or X URL",
        colors: { color: "#ffffff", background: "#000000" },
        iconChoices: ["fa-brands fa-x-twitter"],
        usesOriginUrl: false,
        utmSource: "x",
    },
    share: {
        value: "share",
        label: "Share",
        type: "share",
        defaultText: "Share",
        icon: "fa-solid fa-share-nodes",
        placeholder: "",
        colors: DEFAULT_BUTTON_COLORS,
        iconChoices: ICON_CHOICES.share,
        usesOriginUrl: true,
        utmSource: "share",
    },
    phone: {
        value: "phone",
        label: "Phone Call",
        type: "phone",
        defaultText: "Call",
        icon: "fa-solid fa-phone",
        placeholder: "+1 555 555 5555",
        colors: DEFAULT_BUTTON_COLORS,
        iconChoices: ICON_CHOICES.phone,
        usesOriginUrl: false,
        utmSource: "phone",
    },
    email: {
        value: "email",
        label: "Send Email",
        type: "email",
        defaultText: "Email",
        icon: "fa-solid fa-envelope",
        placeholder: "email@example.com",
        colors: DEFAULT_BUTTON_COLORS,
        iconChoices: ICON_CHOICES.email,
        usesOriginUrl: false,
        utmSource: "email",
    },
    sms: {
        value: "sms",
        label: "Send Text",
        type: "sms",
        defaultText: "Text",
        icon: "fa-solid fa-commenting",
        placeholder: "Phone number or message",
        colors: DEFAULT_BUTTON_COLORS,
        iconChoices: ICON_CHOICES.sms,
        usesOriginUrl: false,
        utmSource: "sms",
    },
};

export const CONNECT_BUTTON_TYPE_OPTIONS = [
    "continue",
    "redirect",
    "facebook",
    "instagram",
    "linkedin",
    "x",
    "share",
    "phone",
    "email",
    "sms",
].map((key) => ({
    value: key,
    label: CONNECT_BUTTON_PRESETS[key].label,
}));

const SOCIAL_HOSTS = {
    facebook: ["facebook.com", "fb.com"],
    instagram: ["instagram.com"],
    linkedin: ["linkedin.com"],
    x: ["x.com", "twitter.com"],
};

const getPresetFromButton = (buttonOrSelection) => {
    if (!buttonOrSelection) return null;
    if (typeof buttonOrSelection === "string") {
        return CONNECT_BUTTON_PRESETS[buttonOrSelection] || null;
    }
    const selectionValue = getConnectButtonSelectionValue(buttonOrSelection);
    return CONNECT_BUTTON_PRESETS[selectionValue] || null;
};

const looksLikeHostedUrl = (value, hosts = []) => {
    const lowerValue = value.toLowerCase();
    return lowerValue.startsWith("http://")
        || lowerValue.startsWith("https://")
        || lowerValue.startsWith("www.")
        || hosts.some((host) => lowerValue.includes(host));
};

const appendTrackingParams = (url, trackingParams = {}) => {
    const entries = Object.entries(trackingParams).filter(([, value]) => value);
    if (!url || url === "#" || entries.length === 0) return url;

    try {
        const parsedUrl = new URL(url);
        entries.forEach(([key, value]) => parsedUrl.searchParams.set(key, value));
        return parsedUrl.toString();
    } catch {
        return url;
    }
};

export const buildConnectClickUrl = ({
    serverOrigin = process.env.REACT_APP_LQR_AI_ORIGIN,
    qrId,
    buttonId,
    originUrl,
    utmSource = "",
    utm_source,
    utm_medium = "",
    utm_campaign = "",
    utm_content = "",
    utm_term = "",
} = {}) => {
    const base = String(serverOrigin || "").replace(/\/+$/, "");
    if (!base || !qrId || !buttonId) return "";

    const params = new URLSearchParams();
    const normalizedUtmSource = String(utm_source ?? utmSource ?? "").trim();

    if (originUrl) params.set("originUrl", originUrl);
    if (normalizedUtmSource) params.set("utm_source", normalizedUtmSource);
    if (utm_medium) params.set("utm_medium", utm_medium);
    if (utm_campaign) params.set("utm_campaign", utm_campaign);
    if (utm_content) params.set("utm_content", utm_content);
    if (utm_term) params.set("utm_term", utm_term);

    const query = params.toString();
    const path = `${base}/connect-click/${encodeURIComponent(qrId)}/${encodeURIComponent(buttonId)}`;

    return query ? `${path}?${query}` : path;
};

const normalizeSocialUrl = (platform, value) => {
    if (!value || typeof value !== "string") return "";

    const trimmedValue = value.trim();
    if (!trimmedValue) return "";

    if (looksLikeHostedUrl(trimmedValue, SOCIAL_HOSTS[platform])) {
        return ensureHttpProtocol(trimmedValue);
    }

    const normalizedPath = trimmedValue.replace(/^@/, "").replace(/^\/+/, "");

    switch (platform) {
        case "facebook":
            return `https://www.facebook.com/${normalizedPath}`;
        case "instagram":
            return `https://www.instagram.com/${normalizedPath}`;
        case "linkedin":
            if (/^(in|company|school|showcase|pub)\//i.test(normalizedPath)) {
                return `https://www.linkedin.com/${normalizedPath}`;
            }
            return `https://www.linkedin.com/in/${normalizedPath}`;
        case "x":
            return `https://x.com/${normalizedPath}`;
        default:
            return ensureHttpProtocol(trimmedValue);
    }
};

export const getConnectButtonSelectionValue = (button = {}) => {
    if (button.type === "redirect" && button.platform && CONNECT_BUTTON_PRESETS[button.platform]) {
        return button.platform;
    }
    return button.type || "";
};

export const getConnectButtonDefaultText = (buttonOrSelection) => getPresetFromButton(buttonOrSelection)?.defaultText || "";

export const getConnectButtonDefaultIcon = (buttonOrSelection) => getPresetFromButton(buttonOrSelection)?.icon || "";

export const getConnectButtonColors = (buttonOrSelection) => getPresetFromButton(buttonOrSelection)?.colors || DEFAULT_BUTTON_COLORS;

export const getConnectButtonValuePlaceholder = (buttonOrSelection) => getPresetFromButton(buttonOrSelection)?.placeholder || "Value";

export const connectButtonUsesOriginUrl = (buttonOrSelection) => !!getPresetFromButton(buttonOrSelection)?.usesOriginUrl;

export const connectButtonRequiresValue = (buttonOrSelection) => {
    const preset = getPresetFromButton(buttonOrSelection);
    return !!preset && !preset.usesOriginUrl;
};

export const isConnectButtonComplete = (button = {}) => {
    const type = String(button?.type || "").trim();
    const text = String(button?.text || "").trim();

    if (!type || !text) {
        return false;
    }

    if (connectButtonRequiresValue(button)) {
        return String(button?.value || "").trim().length > 0;
    }

    return true;
};

export const filterCompleteConnectButtons = (buttons = []) => {
    if (!Array.isArray(buttons)) {
        return [];
    }

    return buttons.filter(isConnectButtonComplete);
};

export const getConnectButtonIconChoices = (buttonOrSelection) => getPresetFromButton(buttonOrSelection)?.iconChoices || [];

export const getConnectButtonUtmSource = (buttonOrSelection) => getPresetFromButton(buttonOrSelection)?.utmSource || "";

export const shouldSyncConnectButtonPresetStyles = (button = {}, previousSelection = "") => {
    const previousColors = getConnectButtonColors(previousSelection);
    const currentColor = button.color || DEFAULT_BUTTON_COLORS.color;
    const currentBackground = button.background || DEFAULT_BUTTON_COLORS.background;

    return (
        (!button.color && !button.background)
        || (currentColor === DEFAULT_BUTTON_COLORS.color && currentBackground === DEFAULT_BUTTON_COLORS.background)
        || (currentColor === previousColors.color && currentBackground === previousColors.background)
    );
};

export const normalizeConnectButtonTarget = (button = {}) => {
    const preset = getPresetFromButton(button);
    const rawValue = button?.value || "";
    if (!rawValue || typeof rawValue !== "string") return "";

    if (preset?.platform) {
        return normalizeSocialUrl(preset.platform, rawValue);
    }

    if (preset?.type === "redirect") {
        return ensureHttpProtocol(rawValue.trim());
    }

    return rawValue.trim();
};

export const resolveConnectButtonHref = (
    button = {},
    {
        qrId = "",
        safeContinueUrl = "",
        defaultUrl = "",
        trackingParams = {},
        connectClickOrigin = process.env.REACT_APP_LQR_AI_ORIGIN,
        originUrl = "",
        utmSource = "",
    } = {},
) => {
    const preset = getPresetFromButton(button);
    const fallbackUrl = safeContinueUrl || defaultUrl || "#";
    let href = "#";
    let target;
    let rel;

    switch (preset?.type) {
        case "continue":
            href = buildConnectClickUrl({
                serverOrigin: connectClickOrigin,
                qrId,
                buttonId: button?.id,
                originUrl,
                utm_source: utmSource,
                utm_medium: "qr",
            }) || fallbackUrl;
            break;
        case "share":
            href = fallbackUrl;
            break;
        case "redirect":
            href = normalizeConnectButtonTarget(button) || defaultUrl || "#";
            if (href !== "#") {
                const connectClickUrl = buildConnectClickUrl({
                    serverOrigin: connectClickOrigin,
                    qrId,
                    buttonId: button?.id,
                    originUrl,
                    utm_source: utmSource,
                    utm_medium: "qr",
                });

                if (connectClickUrl) {
                    href = connectClickUrl;
                }
            }
            break;
        case "email":
            href = button?.value ? `mailto:${button.value}` : "#";
            break;
        case "sms":
            href = button?.value ? `sms:${button.value}` : "#";
            break;
        case "phone":
            href = button?.value ? `tel:${button.value}` : "#";
            break;
        default:
            href = "#";
    }

    if (href.startsWith("http://") || href.startsWith("https://")) {
        href = appendTrackingParams(href, trackingParams);
        target = "_blank";
        rel = "noopener noreferrer";
    }

    return { href, target, rel };
};
